import { Injectable } from '@angular/core';
import { AuthService } from '@app/services';
import { Paginator } from '@app/classes';
import { Invoice } from '@models/settings/billing/invoice.model';
import { Table } from '@app/modules/table/classes/table.class';
import {
    DueDateColumn,
    PeriodStartColumn,
    PeriodEndColumn,
    AmountColumn,
    StatusColumn,
    LinkColumn,
} from '@settings/services/tables/invoice-table/columns';

@Injectable()
export class InvoiceIndexTable extends Table {
    links = false;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.addColumns(
            new DueDateColumn(),
            new PeriodStartColumn(),
            new PeriodEndColumn(),
            new AmountColumn(),
            new StatusColumn(),
            new LinkColumn()
        );
    }

    setDataSource(): void {
        this.paginator = new Paginator(Invoice.query());
    }
}
